import { useDisclosure } from "@heroui/react";
import { useEffect, useState } from "react";
import { TicketTypeSelectionModal } from "./ticketTypeSelectionModal";
import { CreateUserToLandlordTicketModal } from "./createUserToLandlordTicketModal";
import { CreateToPlatformTicketModal } from "./createToPlatformTicketModal";

export function CreateTicketModal({
  disclosure,
}: {
  disclosure: ReturnType<typeof useDisclosure>;
}) {
  const typeSelectionDisclosure = useDisclosure();
  const userToLandlordDisclosure = useDisclosure();
  const toPlatformDisclosure = useDisclosure();
  const [type, setType] = useState<string | null>(null);

  const handleSelectType = (
    type: "user_to_landlord" | "to_platform" | "cancel",
  ) => {
    setType(type);
    if (type === "cancel") {
      disclosure.onClose();
      setType(null);
      return;
    } else if (type === "user_to_landlord") {
      userToLandlordDisclosure.onOpen();
    } else {
      toPlatformDisclosure.onOpen();
    }
  };

  useEffect(() => {
    if (
      disclosure.isOpen &&
      !typeSelectionDisclosure.isOpen &&
      !userToLandlordDisclosure.isOpen &&
      !toPlatformDisclosure.isOpen
    ) {
      if (type !== null) {
        disclosure.onClose();
        setType(null);
      }
      typeSelectionDisclosure.onOpen();
    }
  }, [
    disclosure.isOpen,
    toPlatformDisclosure.isOpen,
    typeSelectionDisclosure,
    userToLandlordDisclosure.isOpen,
    type,
  ]);

  useEffect(() => {
    if (!disclosure.isOpen) {
      typeSelectionDisclosure.onClose();
      userToLandlordDisclosure.onClose();
      toPlatformDisclosure.onClose();
    }
  }, [
    disclosure.isOpen,
    toPlatformDisclosure,
    typeSelectionDisclosure,
    userToLandlordDisclosure,
  ]);

  return (
    <>
      <TicketTypeSelectionModal
        disclosure={typeSelectionDisclosure}
        onSelectType={handleSelectType}
      />

      <CreateUserToLandlordTicketModal disclosure={userToLandlordDisclosure} />

      <CreateToPlatformTicketModal disclosure={toPlatformDisclosure} />
    </>
  );
}
